import clsx from "clsx";
import { useEffect, useState } from "react";
import { ToolbarButton } from "..";
import { IModel } from "../../interface/IModel";
import { generateImageResource, ImageResource } from "../../utils";
import { ImageViewer } from "../image-viewer";

type ViewerState = {
    visible: boolean;
    selected: string;
};

type ImageButtonProps = {
    isMobile: boolean;
    model: IModel;
};

export const ImageButton = ({ isMobile, model }: ImageButtonProps) => {
    const [imageResource, setImageResource] = useState<ImageResource | null>(null);
    const [viewer, setViewer] = useState<ViewerState>({
        visible: false,
        selected: "",
    });

    useEffect(() => {
        if (model) {
            const resources = model.outliner.imageResouce;

            if (resources) {
                const imgResource = generateImageResource(model.outliner.imageResouce);
                setImageResource(imgResource);
            } else {
                setImageResource(null);
                setViewer({ visible: false, selected: "" });
            }
        }

        if (!model) {
            setImageResource(null);
        }
    }, [model]);

    return model && imageResource ? (
        <>
            {model && (
                <ToolbarButton
                    text="Images"
                    image={`${model.outliner.imageResouce?.path}1_thumb.png` || ""}
                    onClick={() => {
                        setViewer({
                            visible: true,
                            selected: imageResource.primary,
                        });
                    }}
                />
            )}

            <ImageViewer
                className={clsx(isMobile && "mobile")}
                onClosed={() => {
                    setViewer({ visible: false, selected: "" });
                }}
                visible={viewer.visible}
                images={imageResource.images}
                image={viewer.selected}
            />
        </>
    ) : null;
};
